import { Flex, Link, Text } from '@servicetitan/anvil2';
import {
    FINTURF_E_CONSENT_URL,
    FINTURF_IMPORTANT_DISCLOSURES_URL,
    FINTURF_PRIVACY_POLICY_URL,
    FINTURF_TCPA_PARTNERS_URL,
    FINTURF_TERMS_URL,
} from './finturfDisclosureUrls';

export interface FinturfDisclosureTextProps {
    /**
     * First-look lender name used in the soft-pull acknowledgment.
     * Omit for direct Finturf applications where there is no first-look waterfall.
     */
    firstLookLenderName?: string;
}

const stopCheckboxToggle = (event: { stopPropagation: () => void }) => {
    // When this text is used as a Checkbox label, prevent link clicks from toggling the checkbox.
    event.stopPropagation();
};

export const FinturfDisclosureText = ({ firstLookLenderName }: FinturfDisclosureTextProps) => {
    return (
        <Flex direction="column" gap="4">
            {firstLookLenderName && (
                <Text variant="body">
                    I also understand that if {firstLookLenderName} has no available offers, the
                    above information will be sent to Finturf, and Finturf may conduct a soft pull
                    of my credit that will not affect my credit score.
                </Text>
            )}
            <Text variant="body">
                I read and agree to Finturf's{' '}
                <Link
                    href={FINTURF_PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={stopCheckboxToggle}
                >
                    Privacy Policy
                </Link>
                ,{' '}
                <Link
                    href={FINTURF_TERMS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={stopCheckboxToggle}
                >
                    Terms & Conditions
                </Link>
                ,{' '}
                <Link
                    href={FINTURF_E_CONSENT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={stopCheckboxToggle}
                >
                    Consent for Electronic Signatures & Records
                </Link>
                , and{' '}
                <Link
                    href={FINTURF_IMPORTANT_DISCLOSURES_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={stopCheckboxToggle}
                >
                    Important Disclosures
                </Link>
                .
            </Text>
            <Text variant="body">
                I authorize Finturf to (a) obtain my consumer credit report(s) for the purpose of
                determining my eligibility to receive consumer credit products offered by Finturf's
                finance providers; and (b) share my credit report information with the finance
                provider I select in order to obtain a loan offer(s) in connection with a credit
                transaction.
            </Text>
            <Text variant="body">
                I agree and provide my express written consent authorizing Finturf, its{' '}
                <Link
                    href={FINTURF_TCPA_PARTNERS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={stopCheckboxToggle}
                >
                    financing, leasing and marketing partners
                </Link>
                , to contact me at the number I provided for marketing purposes, including through
                automated technology, SMS/ MMS messages, and artificial intelligence, prerecorded
                and/or artificial voice messages, even if my number is on a federal, state, or
                corporate Do Not Call (DNC) list. I acknowledge my consent is not required as a
                condition to use this service and msg/data rates may apply.
            </Text>
            <Text variant="body">
                I understand Finturf is NOT a lender or lessor, does not make offers for financing
                or leasing applications, and does not make credit decisions.
            </Text>
        </Flex>
    );
};
